export default "__VITE_ASSET__a07c2d18__"